import { Menu, ListItemText, Icon, Typography, styled } from '@nextiva/next-ui-components';

export const StyledMenu = styled(Menu)({
  '& > .MuiPaper-root': {
    width: 214,
  },
});

export const StyledListItemText = styled(ListItemText)({
  '& > .MuiTypography-root': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& *:not(:last-child)': {
      marginRight: 8,
    },
  },
});

export const StyledInput = styled('input')(({ theme }) => ({
  fontFamily: 'Lato, lato, sans-serif',
  padding: '8px 16px',
  border: `1px solid  ${theme.palette.blueGrey.A200}`,
  boxSizing: 'border-box',
  borderRadius: '4px',
  '::placeholder': {
    color: theme.palette.blueGrey.A300,
  },
}));

export const StyledForm = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  padding: '16px 16px 0px 16px',
  marginBlockEnd: 0,
  width: '328px',
});

export const StyledIcon = styled(Icon)(({ theme }) => ({
  color: theme.palette.blueGrey.A400,
  fontSize: 14,
  fontWeight: 400,
}));

export const StyledNarrowCheckIcon = styled(Icon)(({ theme }) => ({
  color: theme.palette.blueGrey.A400,
  fontSize: 14,
  width: 13,
  fontWeight: 400,
}));

export const StyledSmallIcon = styled(Icon)(({ theme }) => ({
  color: theme.palette.blueGrey.A400,
  fontSize: 10,
  fontWeight: 400,
}));

export const StyledLabel = styled('label')({
  marginBottom: 8,
});

export const StyledTypography = styled(Typography)({
  width: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  marginRight: 8,
});

export const StyledBillingAndLicensingContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const StyledNewIconContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  backgroundColor: theme.palette.blue['50'],
  borderRadius: '4px',
  color: theme.palette.primary.main,
  margin: '4px 0px 0px 8px',
  padding: '2px 8px',
}));
